import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Item } from '../Item'
import { ShippingCalculator } from './ShippingCalculator'

const List = props => {
  const {
    items,
    removeItem,
    updateItem,
    stores,
    isUpdating,
    isLoading,
    onlyCash,
    decimalPlaces,
    pointsName,
    shippingAddress,
    errorData
  } = props
  const ready = !isLoading && !isUpdating

  const list = items.map((item, key) => {
    const hasShipping =
      props.shipping.vendors && props.shipping.vendors.length > 0

    const getVendor = () => {
      const vendor = props.shipping.vendors.filter(({ id }) => id === item.vendor.id)[0]
      return vendor && vendor.length > 0 ? vendor[0] : null
    }

    const shippingVendor = hasShipping ? getVendor() : null

    let deliveryDate = ''

    if (shippingVendor) {
      deliveryDate = moment(shippingVendor.deliveryDate).format('DD/MM/YYYY')
    }

    let vendor = stores.filter(store => store.supplierId === item.vendor.id)[0]

    const data = {
      ...item,
      items,
      key,
      removeItem,
      updateItem,
      deliveryDate,
      vendorName: vendor ? vendor.name : '',
      ready,
      onlyCash,
      errorData
    }
    return (
      <Item {...data} decimalPlaces={decimalPlaces} pointsName={pointsName} sendGTM={props.sendGTM} />
    )
  })

  let zipCode = shippingAddress ? shippingAddress.zipCode : ''
  const zipCodeParticipant =
    props.participant &&
    props.participant.address &&
    props.participant.address.zipCode
      ? props.participant.address.zipCode.value
      : ''
  zipCode = zipCode || zipCodeParticipant

  return (
    <div className='container-cart-list cart-side col-12 col-md-8 px-0 pr-md-2 mb-2 mb-md-0'>
      <div className='border-ui-3 radius bg-white'>
        <div className='cart-side-title col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
          <h1 className='color-title txt-font-body'>Carrinho de compras</h1>
        </div>
        <div className='cart-products col-12 mx-0'>
          {list}
          {props.hasItemsDifferentVirtualVoucher ? (
            <ShippingCalculator
              {...props}
              zipCodeValue={zipCode}
              decimalPlaces={props.decimalPlaces}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  )
}

List.propTypes = {
  items: PropTypes.array,
  removeItem: PropTypes.func,
  updateItem: PropTypes.func,
  fetchShipping: PropTypes.func,
  shipping: PropTypes.object,
  hasItemsDifferentVirtualVoucher: PropTypes.any,
  stores: PropTypes.array,
  isUpdating: PropTypes.bool,
  isLoading: PropTypes.bool,
  onlyCash: PropTypes.bool,
  decimalPlaces: PropTypes.number,
  pointsName: PropTypes.string,
  participant: PropTypes.object,
  shippingAddress: PropTypes.object,
  value: PropTypes.any,
  sendGTM: PropTypes.func,
  errorData: PropTypes.object
}

export default List



// WEBPACK FOOTER //
// ./src/features/Cart/List/List.js